export const Codification = {
    path: '/codifications',
    name: 'codifications',
    component: () => import('@/views/Setting/Codification/CodificationPage.vue'),
    children: [
        {
            path: '/codifications/edit/:id',
            name: 'codifications.edit',
            component: () => import('@/views/Setting/Codification/Form/CodificationForm.vue'),
        },
    ]
}